import React from 'react';

import { When } from 'react-if';

import { Box } from '@nerdwallet/currency/components/Box';
import { Link } from '@nerdwallet/currency/components/Link';
import { Text } from '@nerdwallet/currency/components/Text';

import HelpIcon from '@nerdwallet/react-icon/gizmo/Help';

import styles from './dismiss-tracker.module.scss';

interface Props {
  onClick: () => any;
  footerText: string;
  isFundingAccount?: boolean;
}

const NerdwalletPlusRewardFooterBox: React.FC<Props> = ({
  onClick,
  footerText,
  isFundingAccount,
}) => {
  return (
    <React.Fragment>
      <Box
        paddingX="3"
        paddingY="2"
        display="flex"
        flexDirection="row"
        backgroundColor="neutral-lightest"
      >
        <Link onClick={onClick}>
          <Box alignItems="center" display="flex" flexDirection="row">
            <Text size="small" align="center">
              {footerText}
            </Text>
            <When condition={!isFundingAccount}>
              <HelpIcon />
            </When>
          </Box>
        </Link>
        <When condition={isFundingAccount}>
          <Box
            className={styles.arrow}
            tabIndex={0}
            id="footer-div"
            onClick={onClick}
            role="button"
          >
            {'>'}
          </Box>
        </When>
      </Box>
    </React.Fragment>
  );
};

export default NerdwalletPlusRewardFooterBox;
